import React, { Fragment, useEffect, useState } from "react";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import ChatItem from "../ChatItem/ChatItem";
import ChatStateHandler, { useChatState } from "src/StateHandlers/ChatStateHandler";
import { useTranslation } from "react-i18next";

type ChatListProps = {
  placeholderMessage: string;
  setModalVisibility: any,
  setChatData: any
};

function ChatList({
  setModalVisibility,
  placeholderMessage,
  setChatData
}: ChatListProps) {
  const { t, i18n } = useTranslation();
  const [{ chatList = [], online }] = useChatState();
  const [search, setSearch] = useState<string>('')
  useEffect(() => {
    if (online) {
      ChatStateHandler.getChatList();
    }
  }, [online])


  return (
    <Fragment>
      <div className="d-flex justify-content-between mb-4 align-items-center px-3">
        <h3 className="fz16 mb-0">{t("Messages")}</h3>
        <div className="d-flex align-items-center w-50 position-relative">
          <span className={`${i18n.dir()==='rtl'?'ml-4 ':'mr-4 '} cursor-pointer pencil`} onClick={() => setModalVisibility(true)}>
            <i className="fa fa-pencil" style={{ paddingTop: '8px' }} aria-hidden="true"></i>
          </span>
          <input
            type="text"
            className={`form-control fz12 custom_input border-0 ${i18n.dir()==='rtl'?'Almarairegular':' poppinsregular'}`}
            placeholder={t("Search")}
            onChange={e => setSearch(e.target.value)}
          />
          <i className={` fa fa-search ${i18n.dir()==='rtl'?'fa-search-rtl':'fa-search-ltr'}`}></i>
        </div>
      </div>
      <div className="furniture_section">
        <div className="container-fluid">
          <div className="row mt-5">
            <div className="col-md-12">
              <div className="col_selector">
                {chatList.filter((item: any) => {
                  return item.receiverName.toLowerCase().includes(search.toLowerCase()) || item.senderName.toLowerCase().includes(search.toLowerCase())
                }).map((item: any, index: number) => (
                  <ChatItem
                    key={index}
                    {...item}
                    setChatData={setChatData}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ChatList;
